import Vue from "vue"
import App from "./App.vue"
import router from "./router/index"
import store from "./store"
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap/dist/js/bootstrap.bundle.min.js"
import "@fortawesome/fontawesome-free/css/all.css"
import "material-design-icons-iconfont/dist/material-design-icons.css"
import "quill/dist/quill.snow.css"
import "sweetalert2/dist/sweetalert2.min.css"
import "./assets/tailwind.css"
import "./assets/theme.scss"
import VueToast from "vue-toast-notification"
import "vue-toast-notification/dist/theme-sugar.css"
import "bootstrap-vue/dist/bootstrap-vue.css";

import VueGoodTablePlugin from 'vue-good-table';

// import the styles
import 'vue-good-table/dist/vue-good-table.css'

import BootstrapVue from "bootstrap-vue";

// Import wireless scanner service
import wirelessScannerService from '@/services/wireless-scanner-service';

Vue.use(BootstrapVue);
Vue.config.productionTip = false
Vue.use(VueGoodTablePlugin);
Vue.use(VueToast)

// Make scanner service globally available
Vue.prototype.$scanner = wirelessScannerService;

const app = new Vue({
    router,
    store,
    render: (h) => h(App),
})

// Initialize scanner service when app starts
app.$mount("#app")

wirelessScannerService.initialize().catch(err => {
    console.warn('Scanner service initialization failed:', err);
});
